export default {
  NATIONAL: 'national',
  STATE: 'state',
  COUNTY: 'county',
  CLIENT: 'client',
};
